import request from '../utils/request'
const serviceName = 'baseRole'

export function getRoleTree(data) {
  return request({
    url:`/${serviceName}/getRoleTree`,
    method:'post',
    data
  })
}

export function getRoleByUserId(data) {
  return request({
    url:`/${serviceName}/getRoleByUserId`,
    method:'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/baseRole.js